import { Box, Button, Paper, Table, TableBody, TableCell, TableContainer, TableFooter, TableHead, TablePagination, TableRow } from '@mui/material'
import React, { useEffect, useState } from 'react'
import GetAppRoundedIcon from '@mui/icons-material/GetAppRounded';
import { getV2API, getV2ExportAPI } from '../../../network/index.v2';
import { tableData } from '../../../utils';
import EmptyTable from '../../../common/EmptyTable';

export const tableHeader = {
    fontSize: '0.9rem !important',
    fontWeight: 500,
    color: '#45445F',
    px: 3,
    paddingLeft: '5px',
    paddingRight: '5px',
    padding: '12px'
}


const ViewContract = () => {
    const [ContractorList, setContractorList] = useState([])

    // -------------------------------------------- Table States and Static Data Manipulation Start --------------------------------------


    const [page, setPage] = useState(0)
    const [perPages, setPerPages] = useState([10, 25, 50]);
    const [perPage, setPerPage] = useState(10)

    const handleChangePage = (event, newPage) => {
        setPage(newPage);
    };


    const handleChangeRowsPerPage = (event) => {
        console.log(event.target.value)
        setPerPage(event.target.value)
        setPage(0);
    };


    // -------------------------------------------- Table States and Static Data Manipulation Ends --------------------------------------

    const getContractorList = async () => {
        try {
            const response = await getV2API("/maintenance/contractor")
            if (response) {
                setContractorList(response)
            }
        } catch (error) {
            console.log(error, "error from api");
        }
    }

    const handleExport = async(e) => {
        e.preventDefault()

        const response = await getV2ExportAPI("/maintenance/contractor/exports", "Contractor")

    }

    useEffect(() => {
        getContractorList()
    }, [])
    return (
        <div>
            <div>
                <div className='export-button' >
                    <div style={{ display: "flex", gap: "10px" }}>
                        <p className='titles'>Contactor Name</p>
                        <p className='titles'>State</p>
                        <p className='titles'>Status</p>
                    </div>
                    <Button variant="contained" onClick={handleExport} style={{ backgroundColor: "grey" }} sx={{ height: 30, m: 2 }}>
                        <GetAppRoundedIcon /> &nbsp; &nbsp;
                        Export
                    </Button>
                </div>
                <Box display="flex" sx={{ my: "1rem" }}>

                    <TableContainer component={Paper}>

                        <Table
                            sx={{ minWidth: "auto" }}
                            aria-label="custom pagination table"
                            className="responsive-table"
                        >
                            <TableHead>
                                <TableRow className="table-header">
                                    <TableCell align="left" component="th" sx={tableHeader}>
                                        Contractor Number
                                    </TableCell>
                                    <TableCell align="left" component="th" sx={tableHeader}>
                                        Contractor Name
                                    </TableCell>
                                    <TableCell align="left" component="th" sx={tableHeader}>
                                        ABN
                                    </TableCell>
                                    <TableCell align="left" component="th" sx={tableHeader}>
                                        Email
                                    </TableCell>
                                    <TableCell align="left" component="th" sx={tableHeader}>
                                        Phone Number
                                    </TableCell>
                                    <TableCell align="left" component="th" sx={tableHeader}>
                                        Contact Name
                                    </TableCell>
                                    <TableCell align="center" component="th" sx={tableHeader}>
                                        Address
                                    </TableCell>
                                    <TableCell align="center" component="th" sx={tableHeader}>
                                        Suburb
                                    </TableCell>
                                    <TableCell align="center" component="th" sx={tableHeader}>
                                        State
                                    </TableCell>
                                    <TableCell align="center" component="th" sx={tableHeader}>
                                        Postcode
                                    </TableCell>
                                    <TableCell align="center" component="th" sx={tableHeader}>
                                        Status
                                    </TableCell>

                                    <TableCell align="center" component="th" sx={tableHeader}>
                                        Action
                                    </TableCell>
                                    {/* <TableCell align="center" component="th" sx={tableHeader}>
                                        Task Status
                                    </TableCell>
                                    <TableCell align="center" component="th" sx={tableHeader}>
                                        Action
                                    </TableCell> */}

                                </TableRow>
                            </TableHead>
                            <TableBody>


                                {ContractorList.slice(page * perPage, page * perPage + perPage).map((task, index) => (
                                    <TableRow key={index}>
                                        <TableCell align="left" sx={tableData}>
                                            {task?.phoneNumber}
                                        </TableCell>
                                        <TableCell align="left" sx={tableData}>
                                            {task?.contactName}
                                        </TableCell>
                                        <TableCell align="left" sx={tableData}>
                                            {task?.ABN}
                                        </TableCell>
                                        <TableCell align="left" sx={tableData}>
                                            {task?.email}
                                        </TableCell>
                                        <TableCell align="left" sx={tableData}>
                                            {task?.phoneNumber}
                                        </TableCell>
                                        <TableCell align="left" sx={tableData}>
                                            {task?.contactName}
                                        </TableCell>
                                        <TableCell align="left" sx={tableData}>
                                            {task?.address}
                                        </TableCell>
                                        <TableCell align="left" sx={tableData}>
                                            {task?.suburb}
                                        </TableCell>
                                        <TableCell align="left" sx={tableData}>
                                            {task?.state}
                                        </TableCell>
                                        {/* <TableCell align="left" sx={tableData}>

                                            {task?.isMatch === true ?
                                                <Button style={{ color: 'white', backgroundColor: 'green' }}> Matched</Button> :
                                                <Button style={{ color: 'white', backgroundColor: 'red' }} onClick={() => handleMapData(task)}>Mismatch</Button>
                                            }
                                            <i>
                                                {task?.isMatch ? null : `${task?.distance} km away`}
                                            </i>
                                        </TableCell> */}
                                        <TableCell align="left" sx={tableData}>
                                            {task?.postcode}
                                        </TableCell>
                                        
                                        <TableCell align="left" sx={tableData}>
                                            Non Critical
                                        </TableCell>
                                        <TableCell align="left" sx={tableData}>
                                            Pending
                                        </TableCell>
                                        {/* <TableCell align="left" sx={tableData}>
                                            <Button variant="outlined" style={{ color: 'white', backgroundColor: 'green' }} onClick={() => setOpenCheckout(true)}>Checked Out</Button>

                                            <Button variant="outlined" color="error" onClick={() => setOpenCheckout(true)}>Forced Check Out</Button>

                                            <Button variant="outlined" style={{ color: 'white', backgroundColor: 'orange' }} onClick={() => setOpenCheckout(true)}>Check Out</Button>
                                        </TableCell> */}

                                    </TableRow>

                                ))}

                                {
                                    ContractorList.length === 0 &&
                                    <EmptyTable colSpan={6} />
                                }
                            </TableBody>
                            <TableFooter>
                                <TableRow >

                                    <TablePagination
                                        align="right"
                                        rowsPerPageOptions={perPages}
                                        colSpan={7}
                                        count={ContractorList.length}
                                        rowsPerPage={perPage}
                                        page={page}
                                        SelectProps={{
                                            inputProps: {
                                                'aria-label': 'rows per page',
                                            },
                                            native: true,
                                        }}
                                        onPageChange={handleChangePage}
                                        onRowsPerPageChange={handleChangeRowsPerPage}
                                    // ActionsComponent={TablePaginationActions}
                                    />
                                </TableRow>
                            </TableFooter>
                        </Table>
                    </TableContainer>
                </Box>
            </div>
        </div>
    )
}

export default ViewContract